import * as React from "react";
import { useState, useEffect, useRef } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";
import "./Banner.scss";
import BannerImage from "./Image/BannerImage";
import BannerVideo from "./Video/BannerVideo";
import AnimatedLines from "@src/stories/client/AnimatedLines/AnimatedLines";

export const Banner = ({ banners, useCarousel = true, section_settings, props }) => {
  const isMobile = useMobileBreakpoint(section_settings.mobile_breakpoint);
  const carouselRefBanner: any = useRef(null);
  const [parentHeight, setParentHeight] = useState(0);
  const moveDotsAboveOverlay = false;
  const showNavigation = isMobile
    ? section_settings.show_buttons_mobile
    : section_settings.show_buttons;

  const { globals } = props;

  let showButtons = section_settings.show_buttons;
  if (isMobile) {
    showButtons = section_settings.show_buttons_mobile;
  }

  let showDots = section_settings.show_indicators;
  if (isMobile) {
    showDots = section_settings.show_indicators_mobile;
  }

  useEffect(() => {
    const adjustDotsPosition = (reset = false) => {
      // const parentElement: any = document.querySelector(
      //   ".banner .flickity-slider .is-selected .banner_overlay .banner_overlay_content",
      // );
      // const dots: any = document.querySelector(".banner .flickity-page-dots");
      //
      // if (parentElement && dots) {
      //   if (!reset) {
      //     const newHeight = parentElement.offsetHeight;
      //     dots.style.bottom = `${newHeight}px`;
      //     setParentHeight(newHeight);
      //   } else {
      //     dots.style.bottom = `${0}px`;
      //     setParentHeight(0);
      //   }
      // }
    };
    // Optionally, handle resize events to update the height dynamically
    const handleResize = () => {
      // adjustDotsPosition();
    };

    if (isMobile && moveDotsAboveOverlay) {
      // adjustDotsPosition();
      // Clean up the event listener on unmount
    } else {
      // adjustDotsPosition(true);
    }

    // window.addEventListener("resize", handleResize);
    // window.addEventListener("load", handleResize);

    return () => {
      // window.removeEventListener("resize", handleResize);
      // window.removeEventListener("load", handleResize);
    };
  }, [isMobile]);

  return (
    <div
      className={`banner ${section_settings.mobile_height > 0 && `h-[${section_settings.mobile_height}px]`} ${section_settings.is_primary && "lg:h-[87vh]"}`}
      style={!isMobile ? { } : {}}
    >
      {(showNavigation && section_settings.use_carousel) && (
        <div className={"banner-carousel__controls"}>
          <CarouselNavigation
            shiftPageDots={false}
            carouselRef={carouselRefBanner}
            spread={true}
            icons={globals.carousel_icons}
            size={globals.carousel_icons?.carousel_navigation_arrow_size}
          />
        </div>
      )}

      <div
        className={"carousel banner-carousel h-full"}
        {...(useCarousel && {
          "x-data": "extended_carousel",
          "x-init": `$nextTick(() => { initialise(true, false, false, false, ${section_settings.autoplay_speed * 1000}, 'banner', false) })`,
          "x-ref": "carousel",
        })}
        ref={carouselRefBanner}
      >
        {banners.map((blockItem, index) => {
          return (
            <div key={index}>
                  
              {blockItem.type === "block_image" && (
                <>
                <BannerImage
                  section_settings={section_settings}
                  blockItem={blockItem}
                  isMobile={isMobile}
                  isLazy={index !== 0}
                />
                  <AnimatedLines 
                      backgroundColor="transparent"
                      lineColors={['#EDD5C9', '#899B30', '#D6CFF8']}
                      lineCount={2}
                      glowIntensity={10}     
                      animationSpeed={5}
                      lineThickness={1}
                      curveAmplitude={360}
                      verticalCurveAmplitude={360}
                      verticalLineCount={2}
                      showVerticalLines={true}
                      globalOpacity={0.5}
                    />
                    <div className="absolute bottom-0 left-4 lg:left-16 w-[163px] lg:w-[267px]">
                      <img className={`absolute bottom-0 left-0 w-full`} src="https://cdn.shopify.com/s/files/1/1987/3449/files/shopify-platinum-partner-badge_1.png?v=1740573912" />
                    </div>
                </>
              )}
              {blockItem.type === "block_video" && (
                <BannerVideo
                  section_settings={section_settings}
                  blockItem={blockItem}
                  isMobile={isMobile}
                  banners={banners}
                  index={index}
                  globals={globals}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
